module.exports = __webpack_public_path__ + "static/Hero_Logos-2516a58644eaa4c557ba4edc15163773.jpg";